import { ArrowRight } from "lucide-react";

import type { AnalyticsElementId } from "@/lib/analytics/analyticsElementId";
import { deriveAnalyticsElementId } from "@/lib/analytics/deriveAnalyticsElementId";
import { InternalLink } from "@/shared/ui/internal-link";
import type { ArticleDefinition } from "../articleRegistry";
import { ArticleByline } from "./ArticleByline";

import "../blog.css";

type ArticleCardProps = {
  article: ArticleDefinition;
  baseAnalyticsElementId: AnalyticsElementId;
};

export function ArticleCard({ article, baseAnalyticsElementId }: ArticleCardProps) {
  return (
    <article className="blog-article-card">
      <h3>{article.title}</h3>
      <p className="blog-article-summary">{article.summary}</p>
      <InternalLink
        analyticsElementId={deriveAnalyticsElementId(baseAnalyticsElementId, "read-article")}
        href={article.path}
        aria-label={`Read Article: ${article.title}`}
        className="blog-article-link"
      >
        Read Article <ArrowRight size={20} aria-hidden="true" />
      </InternalLink>
      <ArticleByline article={article} />
    </article>
  );
}
